import { FuelGridContainer } from '@frete.com/fuel-react';
import styled, { css } from 'styled-components';
import { CardAnimations } from './constants';
import { slideRight } from './styled.animation';

export const ListItem = styled.li<{
  $active?: boolean;
  $visualized?: boolean;
  $animation: CardAnimations;
  $disableClick: boolean;
}>`
  ${({ theme, $visualized, $active, $animation, $disableClick }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    background: ${theme.color.background.neutral.weak};
    position: relative;
    overflow: hidden;
    justify-content: center;

    @media (min-width: ${theme.breakpoint.lg.minWidth}) {
      ${$active &&
      css`
        &:before {
          content: '';
          height: 74px;
          width: 3px;
          border-radius: ${theme.border.radius.none} ${theme.border.radius.small} ${theme.border.radius.small}
            ${theme.border.radius.none};
          background: ${theme.color.background.brand.default};
          position: absolute;
        }
      `}
    }

    &:hover {
      background: ${theme.color.background.neutral.weak};
    }

    ${!$visualized &&
    css`
      background: ${theme.color.background.neutral.default};
    `}

    ${$animation === CardAnimations.RIGHT &&
    css`
      animation: ${slideRight} 0.6s cubic-bezier(0.32, 0, 1, -0.1) 0.2s forwards;
    `}

     ${$disableClick &&
    css`
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
      pointer-events: none;
    `}
  `}
`;

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: space-around;
`;

export const TruckerContainer = styled.div<{ $showDivider: boolean }>`
  ${({ $showDivider }) =>
    $showDivider &&
    css`
      border-bottom: ${({ theme }) => theme.border.width.thinner} ${({ theme }) => theme.border.style.solid}
        ${({ theme }) => theme.color.border.neutral.default};
    `}

  .grid-container.sc-fuel-grid-container-h {
    margin: 0;
    width: 100%;
  }
`;

export const CityDistrict = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;

  ${({ isMobile }) =>
    isMobile &&
    css`
      align-items: start;
      color: ${({ theme }) => theme.color.text.neutral.strong};
      margin-left: 15px;
    `}
`;

export const Distance = styled.div<{ hasDistanceInfo: boolean }>`
  align-items: center;
  color: ${({ theme }) => theme.color.text.neutral.weak};
  display: flex;
  margin-top: 6px;

  fuel-icon {
    margin-right: 3px;
  }

  ${({ hasDistanceInfo }) =>
    hasDistanceInfo &&
    css`
      text-transform: uppercase;
    `}
`;

export const Destiny = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.color.text.neutral.default};
  display: flex;
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  height: 100%;
`;

export const GridContainerMobile = styled(FuelGridContainer)`
  padding: ${({ theme }) => theme.spacing.km6};
`;
